<template>
  <div>
    <AppTwoColumnsSelector
      :items="brandListAll"
      :value="targetBrandOrCarName.brandNames"
      :is-show-all-select="true"
      @changeChosenItems="targetBrandOrCarName.brandNames = $event"
      available-label="ブランド一覧"
      chosen-label="指定対象"
      class="mb-3"
    />
    <AppForm label="車名を指定する場合" class="app-form" />
    <p class="ml-3">
      下記ファイルをダウンロードして、車名をご指定のうえアップロードして下さい。<br />該当の車名がない場合、備考欄にご記入ください。
    </p>
    <div class="format mx-5 mb-3">
      車名指定フォーマット
      <a :href="uri" :download="fileName">
        <v-icon>save_alt</v-icon>
      </a>
    </div>
    <AppFileDropArea :mime-types="mimeTypes" @files="onDropCSVFile">
      <v-layout class="dropArea pa-2 mb-1 justify-center align-center">
        <v-icon>file_copy</v-icon>
        ここに車名指定ファイルをドラッグ
      </v-layout>
      <template v-slot:drag>
        <v-layout
          class="dropArea dragging pa-2 mb-1 justify-center align-center"
        >
          <v-icon>file_copy</v-icon>
          ドロップしてCSVファイルの内容を読み込む
        </v-layout>
      </template>
    </AppFileDropArea>
    <p v-if="uploadFile.fileName">ファイル名：{{ uploadFile.fileName }}</p>
  </div>
</template>

<script>
import { mimeTypes } from '@/components/App/AppFileDropArea'
import { BrandList } from '@/models/CampaignOperation/BrandList'

export default {
  name: 'CampaignModalPageAutomobileBrandOrCarName',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      brandListAll: [],
      resultBrandList: [],
      uri: '/files/all-menu/自動車_車名一覧.xlsx',
      fileName: '自動車_車名一覧.xlsx',
    }
  },
  computed: {
    targetBrandOrCarName() {
      return this.menuSetting.orderDescription.targetBrandOrCarName
    },
    uploadFile() {
      return this.menuSetting.uploadFile
    },
    mimeTypes() {
      return Object.values(mimeTypes.csv)
    },
  },
  created() {
    this.fetchBrandList()
  },
  methods: {
    fetchBrandList() {
      this.brandListAll = BrandList.map(brand => {
        return {
          name: brand,
          value: brand,
        }
      })
    },
    onDropCSVFile(files) {
      const [file] = files
      this.uploadFile.file = file
      this.uploadFile.fileName = file.name
    },
    validate() {
      return true
    },
  },
}
</script>

<style scoped lang="scss">
.dropArea {
  border: 4px dotted #666;
  border-radius: 4px;
  height: 100px;
  transition: all 0.5s linear;

  &.dragging {
    height: 200px;
    background-color: lighten(lightgreen, 5%);
  }
}
.format {
  font-weight: bold;
  font-size: 150%;
}
</style>
